/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const FormViewService = {
  /**
   * Get Screen data
   *
   * */
  async getByCode(url, code, expand) {
    const requestScreenData = {
      url: "api/" + url,
      top: "1",
      filter: `Code eq '${code}'`,
    };

    if (expand) requestScreenData.expand = expand;

    return await ApiService.oDataGet(requestScreenData);
  },
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  async save(url, payload) {
    return await ApiService.post("/api/" + url, payload);
  },
};

export { FormViewService };
